
















































































































































































































import { AccountTypeEnum, TenantUserModel, WorkTaskModel, WorkTaskStatementModel } from '@/libs/Api';
import { useObjectKey } from '@/libs/common/functions/use-object-key';
import { createAggregationQueryPayload } from '@/libs/core/+state/models/aggregation-query-payload';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { workTaskStatementsStore } from '@/libs/work-task-statements/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import StatementDetailDialog from '@/libs/statements/components/StatementDetailDialog.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudOrderBy } from '@/libs/core/+state/models/crud-order-by';

@Component({
    components: {
        StatementDetailDialog
    }
})
export default class Statements extends Page {

    pageInitialization = true;
    filterStart: string | null = null;
    filterEnd: string | null = null;
    filterUser: string | null = null;
    mobileFiltersShow = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "workTask.time" ];
    sortDesc = [ true ];

    headers = [
        { text: "Datum", value: "workTask.time", align: "left", width: "10%" },
        { text: "Pečovatel", value: "user.lastName", align: "left", width: "10%" },
        { text: "Úkon", value: "workTask.catalogueItem.name", align: "left" },
        { text: "Cena za jednotku", value: "workTask.unitPrice", align: "left", width: "10%" },
        { text: "Množství", value: "amount", align: "left", width: "10%" },
        { text: "Návštěva", value: "visitNumber", align: "left", width: "10%" },
        { text: "Cena", value: "price", align: "left", width: "10%" },
        { text: "", value: "id", align: "left", width: "10%" },
    ]

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Ref() exportDialog!: any;
    @Ref() deleteDialog!: any;
    @Ref() dialog!: StatementDetailDialog;

    @Watch("filterStart")
    @Watch("filterEnd")
    @Watch("filterUser")
    filtersChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    get workTaskStatements () {
        return [...workTaskStatementsStore.useGetter(CrudGetter.Data)];
    }

    get loading () {
        return workTaskStatementsStore.useGetter(CrudGetter.Pending);
    }

    get totalRows (): number {
        return ({...workTaskStatementsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get moneySum () {
        return workTaskStatementsStore.useGetter(CrudGetter.Sum);
    }

    get exporting(): boolean {
        return workTaskStatementsStore.useGetter(CrudGetter.Downloading);
    }

    mounted () {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        if (tenantUser.accountType == AccountTypeEnum.Worker || tenantUser.accountType == AccountTypeEnum.Volunteer) {
            this.$router.replace({
                name: "PartyGeneral",
                params: {
                    tenantId: this.$router.currentRoute.params.tenantId,
                    partyId: this.$router.currentRoute.params.partyId,
                }
            })
        }
        else {
            this.load();
        }
    }

    load () {
        const orderBy: CrudOrderBy<WorkTaskStatementModel>[] = [];
        if (this.sortBy.length == 0) {
            orderBy.push({
                field: "workTask.time",
                index: 1,
                order: "desc"
            });
        }
        else {
            orderBy.push({
                field: this.sortBy.first(),
                index: 1,
                order: this.sortDesc.first() ? "desc" : "asc"
            });
        }
        const filters = this.getFilters();
        workTaskStatementsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskStatementModel>(orderBy, this.getFilters(), {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }));
        this.subscribe(workTaskStatementsStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false;
        })
        this.loadSum();
    }

    loadSum () {
        workTaskStatementsStore.dispatch(CrudAction.GetSum, createAggregationQueryPayload(this.getFilters(), useObjectKey<WorkTaskStatementModel>("price")))
    }

    getFilters (): any {

        const filters = [
            { field: "workTask.partyWorkDay.partyId", op: "eq", comparand: this.partyId }
        ] as Array<any>;

        if (this.filterStart) 
            filters.push({ field: "workTask.time", op: "gte", comparand: moment(this.filterStart).format("YYYY-MM-DDT00:00:00") });
        
        if (this.filterEnd) 
            filters.push({ field: "workTask.time", op: "lte", comparand: moment(this.filterEnd).format("YYYY-MM-DDT23:59:59") });
        
        if (this.filterUser) 
            filters.push({ field: "userId", op: "eq", comparand: this.filterUser });

        return filters;

    }

    getPayload() {
        return createCrudQueryPayload<WorkTaskStatementModel>({ field: "workTask.time", index: 1, order: "asc" }, this.getFilters());
    }

    exportClick () {
        this.exportDialog.open();
    }

    exportDownload () {
        workTaskStatementsStore.dispatch(CrudAction.Download, this.getPayload());
        this.subscribe(workTaskStatementsStore, CrudReponse.Download).then(() => {
            this.exportDialog.close();
        });
    }

    deleteItemClick () {
        this.deleteDialog.open();
    }

    openStatement (item: WorkTaskStatementModel) {
        this.dialog.open(item.id!);
    }

    createStatement () {
        this.dialog.create();
    }

}
